import dagre from '@dagrejs/dagre';
import type { Node, Edge } from '@xyflow/react';

/**
 * Berechnet ein gerichtetes Layout (links nach rechts) für einen Reactflow-Graph
 * via dagre. Es wird die `position` jedes Nodes neu berechnet — alle anderen
 * Eigenschaften bleiben unverändert.
 */
export function layoutNodes(
  nodes: Node[],
  edges: Edge[],
  nodeWidth = 200,
  nodeHeight = 70,
  rankdir: 'LR' | 'TB' = 'LR',
): Node[] {
  if (nodes.length === 0) return [];

  const g = new dagre.graphlib.Graph();
  g.setGraph({ rankdir, nodesep: 40, ranksep: 80 });
  g.setDefaultEdgeLabel(() => ({}));

  for (const n of nodes) {
    g.setNode(n.id, { width: nodeWidth, height: nodeHeight });
  }
  for (const e of edges) {
    if (g.hasNode(e.source) && g.hasNode(e.target)) {
      g.setEdge(e.source, e.target);
    }
  }

  dagre.layout(g);

  return nodes.map((n) => {
    const pos = g.node(n.id);
    if (!pos) return n;
    return {
      ...n,
      position: { x: pos.x - nodeWidth / 2, y: pos.y - nodeHeight / 2 },
    };
  });
}
